export const freelanceWorkHourStart = "9"
export const freelanceWorkHourEnd = "17"